import { isValidElement, ReactNode } from 'react';
import styles from './ComparisonTable.module.css';

type TCellData = { value: string | ReactNode; columnSpan?: number };
type TProps = {
  data: { [key: string]: string | ReactNode | TCellData | undefined }[];
  labels: { [key: string]: string | ReactNode };
};

export const ComparisonTable = ({ data, labels }: TProps) => {
  const keys = Object.keys(labels);

  const renderRow = (key: string, isHeader = false) => {
    const Tag = isHeader ? 'th' : 'td';

    return (
      <tr key={key}>
        <Tag className={styles.labelCell}>{labels[key]}</Tag>
        {data.map((row, rowIndex) => {
          const cellData = row[key];

          if (typeof cellData === 'string' || isValidElement(cellData)) {
            return (
              <Tag className={styles.cell} key={rowIndex}>
                {cellData}
              </Tag>
            );
          } else if (typeof cellData === 'object' && cellData !== null) {
            return (
              <Tag
                className={styles.cell}
                key={rowIndex}
                colSpan={(cellData as TCellData).columnSpan || 1}
              >
                {(cellData as TCellData).value}
              </Tag>
            );
          }
        })}
      </tr>
    );
  };

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead className={styles.thead}>{renderRow(keys[0], true)}</thead>
        <tbody className={styles.tbody}>
          {keys.slice(1).map((key) => renderRow(key))}
        </tbody>
      </table>
    </div>
  );
};
